const isEmptyObject = (obj) => !Object.keys(obj).length;

export default isEmptyObject;
